
export const IntegrationSceleton = () => {
  return (
    <div className="p-6 border rounded-lg shadow-sm bg-white animate-pulse">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded w-48 mb-4"></div>
          <div className="flex items-center mt-2">
            <div className="h-6 w-6 bg-gray-200 rounded-full mr-2"></div>
            <div className="flex-1">
              <div className="h-4 bg-gray-200 rounded w-64 mb-2"></div>
              <div className="h-5 bg-gray-200 rounded w-32"></div>
            </div>
          </div>
        </div>
        <div className="mt-4 sm:mt-0">
          <div className="h-10 bg-gray-200 rounded w-32"></div>
        </div>
      </div>
    </div>
  )
}